module.exports = __webpack_public_path__ + "static/media/Sneaker_Male_Right_low.dd9afbd8.jpg";